<template>
	<div class="in-progress-image-modal">
		<div class="modal-backdrop" @click="close"></div>
		<div class="in-progress-receipt-modal">
			<slot name="body">
				<section class="modal-body">
					<button
						name="close-btn"
						type="button"
						class="btn-close"
						@click="close"
					>
						x
					</button>
					<div v-if="hasImageError" class="image-not-found">
						Image Not Found
					</div>
					<div v-else class="image-container">
						<b-img
							:src="
								`data:image/jpeg;base64,${currentPendingReceipt.Base64Image}`
							"
							alt=""
							@error="onImageError"
						></b-img>
					</div>
					<button
						type="button"
						class="delete-button-footer"
						@click="deleteInProgressReceipt(currentPendingReceipt.ReceiptId)"
					>
						<font-awesome-icon :icon="['fas', 'check']" class="check-icon" />
						<loading :active.sync="asyncDeleting"></loading>
						Delete
					</button>
				</section>
			</slot>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
	name: "InProgressReceiptModal",
	props: ["currentPendingReceipt"],
	data() {
		return {
			hasImageError: false,
			asyncDeleting: false
		};
	},
	components: {
		Loading
	},
	methods: {
		close() {
			this.$emit("close");
		},
		getReceipt() {
			this.$axios
				.get("/receipt?id=" + this.expenseId, { crossdomain: true })
				.then(
					({ data }) => {
						data.Receipt["Amount"] = (
							Math.round(data.Receipt["Amount"] * 100) / 100
						).toFixed(2);
						this.expenseDetail = data.Receipt;
						this.selectedVendorName = this.expenseDetail.VendorName;
						this.selectedCategoryName = this.expenseDetail.CategoryName;
						this.selectedProjectName = this.expenseDetail.ProjectName;
						this.previewImage =
							"https://" +
							this.expenseDetail.FileBucket +
							".s3.amazonaws.com/" +
							this.expenseDetail.UserId +
							"/" +
							this.expenseDetail.FileName;
					},
					e => {
						return e;
					}
				);
		},
		onImageError() {
			this.hasImageError = true;
		},
		async deleteInProgressReceipt(receiptId) {
			try {
				this.asyncDeleting = true;
				await this.$axios.delete("/receipt", {
					data: {
						crossdomain: true,
						id: receiptId
					}
				});
			} catch (error) {
				return error;
			} finally {
				this.$store.dispatch("loadPendingExpense");
				this.asyncDeleting = false;
				this.close();
			}
		}
	}
};
</script>
